/**
 * 代理モード中にアクセス禁止の画面パス
 * 仕様書: AD06 代理機能仕様
 */
export const PROXY_RESTRICTED_PATHS = [
  // AD01: 企業一覧（完全一致のみ、AD02の企業詳細は許可）
  '/admin/company',
  // AD03-05: 企業招待
  '/admin/company/invite',
  // AD05: 全読取パターン一覧
  '/admin/patterns',
  // 全てのマスタ一覧（#3254）
  '/admin/masters',
  // AD06-07: 契約プラン変更
  '/admin/plan_change',
  // AD10-11: 担当者数変更
  '/admin/user_limit_change',
  // パスワード変更・完了
  '/auth/password_change',
  // OCRクレジット追加・完了
  '/admin/ocr_credit_add',
];

/**
 * パスが禁止リストに含まれるかどうかを判定
 * AD02（/admin/company/:companyId）は許可するため、完全一致または接頭辞で判定
 */
export const isProxyRestrictedPath = (pathname: string): boolean => {
  // 企業一覧画面（/admin/company）の完全一致は禁止
  if (pathname === '/admin/company') {
    return true;
  }

  // 禁止パスを先にチェック（/admin/company/invite等が企業詳細の正規表現にマッチして
  // 許可されてしまうのを防ぐため）
  const isRestricted = PROXY_RESTRICTED_PATHS.some(restrictedPath => {
    if (restrictedPath === '/admin/company') {
      return false; // すでに上で処理済み
    }
    // 完全一致または接頭辞一致
    return pathname === restrictedPath || pathname.startsWith(restrictedPath + '/');
  });
  if (isRestricted) {
    return true;
  }

  // /admin/company/:companyId の形式は許可（禁止パスでないことが確認済み）
  const companyDetailRegex = /^\/admin\/company\/[^/]+$/;
  if (companyDetailRegex.test(pathname)) {
    return false;
  }

  // /admin/ 配下の未知のパスは禁止（企業詳細以外）
  if (pathname.startsWith('/admin/')) {
    return true;
  }

  // 禁止リストに含まれないパスは許可
  return false;
};
